import axios from '../axios';
import { useQuery } from 'react-query';
import { map, toNumber } from 'lodash';

export function useMonthwiseAnalyticsOfCorporateCharger(chargerId, year) {
  return useQuery(
    '/corporate/corporateGeneralAnalytics',
    () =>
      axios
        .get(
          `/corporate/corporateGeneralAnalytics?chargerId=${chargerId}&year=${year}`,
        )
        .then((res) => ({
          list: map(res?.data?.data, (item) => ({
            ...item,
            MONTH: toNumber(item.MONTH_DATE.split('-')[0]),
            YEAR: toNumber(item.MONTH_DATE.split('-')[1]),
          })),
        })),
    {
      enabled: !!year,
    },
  );
}

export function useChargerwiseAnalyticsOfCorporate(year) {
  return useQuery(['/corporate/corporateChargerWiseAnalytics', year], () =>
    axios
      .get(`/corporate/corporateChargerWiseAnalytics?year=${year}`)
      .then((res) => res.data),
  );
}

export function useMonthwiseAnalyticsOfCorporate(year) {
  return useQuery(['corporateChargerWiseMonthlyAnalytics', year], () =>
    axios
      .get(`/corporate/corporateChargerWiseMonthlyAnalytics?year=${year}`)
      .then((res) => ({
        list: map(res?.data?.data, (item) => ({
          ...item,
          MONTH: toNumber(item.MONTH_DATE.split('-')[0]),
          YEAR: toNumber(item.MONTH_DATE.split('-')[1]),
        })),
      })),
  );
}

export function useCorporateUserBasedAnalytics() {
  return useQuery('/corporateUserBasedAnalytics', () =>
    axios.get(`/corporate/corporateUserBasedAnalytics`).then((res) => res.data),
  );
}
